import React, { useState, useEffect, useCallback, useRef, useContext } from 'react';
import { StateContext, DispatchContext } from '../context/spotcp-context';
import '../../../styles/spotcp.css';
import { getJSClient } from '../../js_client';
import logger from '../../../utils/logging';

// custom Context Menu container
const ContextMenu = (props) => {
  let client;
  const { chartID, selectedComponentID } = props;

  const [targetBin, setTargetBin] = useState('');
  const contextRef = useRef();
  const chartMenuID = `${chartID}-menu`;

  const { request } = useContext(StateContext);
  const dispatch = useContext(DispatchContext);

  useEffect(() => {
    client = getJSClient();
  });

  // check if user did right click on polaris histogram barchart
  // TODO: maybe find better way to do this
  const isTargetOnHistogram = (target) => {
    return (
      target.getAttribute('aria-label') &&
      target.getAttribute('data-group') &&
      target.getAttribute('class').startsWith('_bar-groups__group')
    );
  };

  // check if user did right click on intented chart with provided chartID
  const isTargetChart = (path) => {
    return path.filter((o) => o.id === chartID).length > 0;
  };

  // logic to determine if show custom right-click menu
  const shouldShowCustomMenu = (path, target) => {
    return isTargetChart(path) && isTargetOnHistogram(target);
  };

  const handleContextMenu = useCallback((e) => {
    const { path, target } = e;
    if (shouldShowCustomMenu(path, target)) {
      e.preventDefault();
      // use aria-label to use the bin name user right clicked on
      setTargetBin(target.getAttribute('aria-label')); 
      let contextElement = document.getElementById(chartMenuID);
      contextElement.style.top = e.clientY + 'px';
      contextElement.style.left = e.clientX + 'px';
      contextElement.classList.add('active');
    }
  }, [targetBin]);

  const handleClick = useCallback((e) => {
    const { target } = e;
    let bin = target.getAttribute('bin');
    if (contextRef.current.classList.contains('active') && bin) {
      // use client to run asin analysis
      client.runAsinAnalysis(dispatch, { ...request, component: selectedComponentID, bin, chartID })
    }
    document.getElementById(chartMenuID).classList.remove('active');
  }, [targetBin]);

  // added event listner for click and contextmenu event
  useEffect(() => {
    document.addEventListener('click', handleClick);
    document.addEventListener('contextmenu', handleContextMenu);
    return () => {
      // for clean up to ensure the custom Event Listener won't effect other page/tool in this website
      document.removeEventListener('click', handleClick);
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  });

  return (
    <React.Fragment>
      {
        <div className="spotcp-context-menu" id={chartMenuID} ref={contextRef}>
          <div key={`${chartID}-analysis`} className="item" bin={targetBin}>
            Analyze [{targetBin}]
          </div>
          <hr />
          <div key={`${chartID}-exit`} className="item" bin="">
            Exit
          </div>
        </div>
      }
    </React.Fragment>
  );
};

export default ContextMenu;



// WEBPACK FOOTER //
// ./src/components/spotcp/custom/context-menu.jsx